import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth, formatApiError } from "@/lib/auth";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };
  const input = "w-full rounded-xl border border-slate-200 px-4 py-3 text-[15px] outline-none focus:border-[#0A2540] focus:ring-4 focus:ring-[#0A2540]/10";

  return (
    <div className="grid min-h-screen place-items-center bg-[#0A2540] px-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-white p-8 text-slate-900 shadow-2xl">
        <Logo onLight />
        <div className="mt-8 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#2F7BFF]"><Lock className="h-3.5 w-3.5" /> Admin</div>
        <h1 className="mt-2 font-display text-2xl font-bold text-[#0A2540]">Sign in to view inquiries</h1>
        <div className="mt-6 space-y-4">
          <input data-testid="admin-login-email" type="email" placeholder="Email" autoComplete="username" className={input} value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="admin-login-password" type="password" placeholder="Password" autoComplete="current-password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>}
        <button data-testid="admin-login-submit" disabled={loading} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[#2F7BFF] py-3.5 font-bold text-white transition-colors hover:bg-[#1F63E0] disabled:opacity-70">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
